module.exports = __webpack_public_path__ + "static/media/Ozike.01ac7d2e.png";